export const features = [
  {
    icon: "shield",
    title: "Vie privée",
    desc: "Vos photos, vidéos et documents sont chiffrés de bout en bout. Personne — pas même nous — ne peut y accéder sans votre mot de passe.",
  },
  {
    icon: "lock",
    title: "Sécurité",
    desc: "En cas de vol ou de perte, verrouillez ou effacez votre téléphone à distance. Protection anti-forensic intégrée pour résister aux extractions non autorisées.",
  },
  {
    icon: "share",
    title: "Partage",
    desc: "Partagez vos fichiers en toute sécurité avec des liens chiffrés à durée limitée. Vous gardez le contrôle total sur qui accède à quoi.",
  },
];

export const benefits = [
  {
    icon: "ban",
    title: "La fin de l'accès à vos données",
    desc: "Fini les applications qui lisent vos photos en arrière-plan. SAFE verrouille l'accès à vos fichiers sensibles.",
  },
  {
    icon: "shield-check",
    title: "Zéro risque de fuite",
    desc: "Chiffrement zero-knowledge : vos données ne quittent jamais votre appareil en clair, même en cas de compromission.",
  },
  {
    icon: "remote",
    title: "Contrôle à distance",
    desc: "Verrouillez ou effacez votre téléphone depuis n'importe où en cas de vol. Vos données restent protégées.",
  },
  {
    icon: "fingerprint",
    title: "Protection profonde",
    desc: "Le mode propriétaire d'appareil ancre la sécurité dans le système Android — impossible à contourner sans réinitialisation.",
  },
];

export const securityItems = [
  {
    icon: "encrypt",
    title: "Chiffrement AES-256",
    desc: "Tous vos fichiers sont chiffrés localement avec un algorithme militaire avant stockage.",
  },
  {
    icon: "zero",
    title: "Zero-knowledge",
    desc: "Votre mot de passe n'est jamais transmis. Nous ne pouvons pas accéder à vos données, même si on nous le demande.",
  },
  {
    icon: "forensic",
    title: "Anti-forensic",
    desc: "Résistance aux outils d'extraction de données. Vos fichiers restent illisibles sans authentification.",
  },
  {
    icon: "owner",
    title: "Mode propriétaire",
    desc: "Contrôle système total via Device Owner — politiques, applications et confidentialité sous votre emprise.",
  },
];

export const steps = [
  {
    num: "01",
    title: "Installez",
    desc: "Téléchargez SAFE sur votre appareil Android compatible et suivez le guide d'installation rapide.",
  },
  {
    num: "02",
    title: "Configurez votre coffre",
    desc: "Créez votre mot de passe, importez vos fichiers sensibles et personnalisez vos règles de sécurité.",
  },
  {
    num: "03",
    title: "Vivez tranquille",
    desc: "Vos données sont protégées. En cas de problème, verrouillez ou effacez tout à distance en un geste.",
  },
];

export const faqItems = [
  {
    question: "SAFE est-il gratuit ?",
    answer:
      "SAFE est actuellement en version bêta gratuite. Nous travaillons sur un modèle freemium qui gardera les fonctionnalités essentielles accessibles à tous.",
  },
  {
    question: "Mes données sont-elles vraiment privées ?",
    answer:
      "Oui. SAFE utilise un chiffrement zero-knowledge : votre mot de passe n'est jamais stocké sur nos serveurs. Seul vous pouvez déchiffrer vos fichiers.",
  },
  {
    question: "Sur quels appareils SAFE fonctionne-t-il ?",
    answer:
      "SAFE est disponible exclusivement sur Android. L'application nécessite un appareil compatible avec le mode propriétaire d'appareil (Device Owner) pour activer la protection complète.",
  },
  {
    question: "Que se passe-t-il si je perds mon téléphone ?",
    answer:
      "Vous pouvez verrouiller ou effacer votre appareil à distance. Grâce au chiffrement, même si quelqu'un accède physiquement au téléphone, vos fichiers restent illisibles.",
  },
  {
    question: "Ai-je besoin de rooter mon téléphone ?",
    answer:
      "Non. SAFE utilise le mode propriétaire d'appareil (Device Owner) d'Android, qui offre un contrôle système complet sans root ni modification du firmware.",
  },
  {
    question: "Comment désinstaller SAFE ?",
    answer:
      "La désinstallation nécessite une réinitialisation d'usine de l'appareil, car le mode propriétaire est profondément ancré dans le système pour votre protection.",
  },
];

export const adbSafeApkInstallationSteps = [
  {
    step_id: 1,
    category: "Sécurité Système",
    title: "Accéder à la Sécurité",
    instruction:
      "Ouvrez les Paramètres de votre appareil et accédez à la section 'Security and privacy' (Sécurité et confidentialité).",
    target_element: "Security and privacy",
    image_reference: "1.jpg",
    skip_to: 6,
  },
  {
    step_id: 2,
    category: "Sécurité Système",
    title: "Sécurité des applications",
    instruction:
      "Appuyez sur l'option 'App security' (Sécurité des applications) pour gérer les protections actives.",
    target_element: "App security",
    image_reference: "2.jpg",
  },
  {
    step_id: 3,
    category: "Sécurité Système",
    title: "Ouvrir Google Play Protect",
    instruction:
      "Sélectionnez 'Google Play Protect' pour accéder aux paramètres de scan de Google.",
    target_element: "Google Play Protect",
    image_reference: "3.jpg",
  },
  {
    step_id: 4,
    category: "Sécurité Système",
    title: "Paramètres de protection",
    instruction:
      "Appuyez sur l'icône de l'engrenage (paramètres) située dans le coin supérieur droit.",
    target_element: "Icône Paramètres",
    image_reference: "4.jpg",
  },
  {
    step_id: 5,
    category: "Sécurité Système",
    title: "Désactiver le scan Play Protect",
    instruction:
      "Désactivez le commutateur 'Scan apps with Play Protect'. Cela est nécessaire pour permettre l'installation d'une application externe.",
    target_element: "Commutateur Scan apps",
    image_reference: "5.jpg",
  },
  {
    step_id: 6,
    category: "Sécurité Système",
    title: "Désactiver le scan Play Protect",
    instruction:
      "Cliquer sur TurnOff/Disable pour désactiver le scan Play Protect.",
    target_element: "Commutateur Scan apps",
    image_reference: "6.jpg",
  },
  {
    step_id: 7,
    category: "Installation",
    title: "Localiser l'APK",
    instruction:
      "Télecharger le fichier et Ouvrez votre gestionnaire de fichiers, allez dans le dossier 'Download' et installez le fichier 'app-release.apk'.",
    target_element: "app-release.apk",
    image_reference: "7.jpg",
    download: "https://backend.safe-app.io/apk/app-release.apk",
    isExternal: true,
  },
  {
    step_id: 8,
    category: "Permissions Avancées",
    title: "Installer aussi LADB",
    instruction:
      "Télecharger le fichier et Ouvrez votre gestionnaire de fichiers, allez dans le dossier 'Download' et installez le fichier 'ladb.apk'.",
    target_element: "Installer",
    image_reference: "8.jpg",
    download: "ladb.apk",
  },
];

export const adbLogoutSteps = [
  {
    step_id: 1,
    category: "Samsung Account",
    title: "Accéder aux paramètres du compte Samsung",
    instruction:
      "Ouvrez l'application Paramètres et appuyez sur l'en-tête de votre profil Samsung situé en haut de la liste.",
    target_element: "Compte Samsung",
    image_reference: "screenshot_1.jpg",
  },
  {
    step_id: 2,
    category: "Samsung Account",
    title: "Initier la déconnexion",
    instruction:
      "En bas de l'écran des paramètres de votre compte, appuyez sur le bouton de déconnexion.",
    target_element: "Se déconnecter",
    image_reference: "screenshot_2.jpg",
  },
  {
    step_id: 3,
    category: "Samsung Account",
    title: "Confirmation de déconnexion",
    instruction:
      "Vérifiez que le message de confirmation 'Vous êtes déconnecté(e)' s'affiche en bas de l'écran.",
    target_element: "Toast notification",
    image_reference: "screenshot_3.jpg",
  },
  {
    step_id: 4,
    category: "Google Account",
    title: "Accéder aux services Google",
    instruction:
      "Retournez dans le menu principal des Paramètres, faites défiler vers le bas et sélectionnez l'option 'Google'.",
    target_element: "Google / Services Google",
    image_reference: "screenshot_4.jpg",
  },
  {
    step_id: 5,
    category: "Google Account",
    title: "Ouvrir le menu du compte",
    instruction:
      "Appuyez sur votre nom ou votre adresse e-mail Google actuelle pour ouvrir les options du compte.",
    target_element:
      "Compte Samsung/Compte Google/ Autre compte administrateur de l'appareil",
    image_reference: "screenshot_5.jpg",
  },
  {
    step_id: 6,
    category: "Google Account",
    title: "Gérer les comptes système",
    instruction:
      "Dans le menu contextuel qui s'affiche, sélectionnez l'option pour gérer les comptes sur cet appareil.",
    target_element: "Gérer les comptes sur cet appareil",
    image_reference: "screenshot_6.jpg",
  },
  {
    step_id: 7,
    category: "Google Account",
    title: "Supprimer le compte",
    instruction:
      "Sur l'écran de gestion du compte spécifique, appuyez sur le bouton 'Supprimer le compte'.",
    target_element: "Supprimer le compte",
    image_reference: "screenshot_7.jpg",
  },
  {
    step_id: 8,
    category: "Google Account",
    title: "Confirmer la suppression définitive",
    instruction:
      "Une boîte de dialogue de confirmation apparaîtra. Appuyez sur 'Supprimer' pour confirmer le retrait du compte de l'appareil.",
    target_element: "Supprimer",
    image_reference: "screenshot_8.jpg",
  },
  {
    step_id: 9,
    category: "Google Account",
    title: "Vérification finale",
    instruction:
      "L'écran 'Gestion des comptes' doit maintenant être vide ou ne plus afficher le compte supprimé.",
    target_element: "Liste des comptes vide",
    image_reference: "screenshot_9.jpg",
  },
];

export const adbDeveloperModeSteps = [
  {
    step_id: 1,
    category: "Mode Développeur",
    title: "Accéder aux informations du téléphone",
    instruction:
      "Ouvrez les Paramètres de votre appareil et descendez tout en bas pour sélectionner 'À propos du téléphone'.",
    target_element: "À propos du téléphone",
    image_reference: "screenshot_01.jpg",
  },
  {
    step_id: 2,
    category: "Mode Développeur",
    title: "Consulter les infos logicielles",
    instruction:
      "Appuyez sur la section 'Informations sur le logiciel' pour afficher les détails du système.",
    target_element: "Informations sur le logiciel",
    image_reference: "screenshot_02.jpg",
  },
  {
    step_id: 3,
    category: "Mode Développeur",
    title: "Activer le mode Développeur",
    instruction:
      "Appuyez 7 fois rapidement sur 'Numéro de version'. Un message vous demandera de confirmer l'activation.",
    target_element: "Numéro de version",
    image_reference: "screenshot_03.jpg",
  },
  {
    step_id: 4,
    category: "Mode Développeur",
    title: "Confirmer l'activation",
    instruction:
      "Appuyez sur 'OK' dans la boîte de dialogue de sécurité pour finaliser l'activation du mode.",
    target_element: "Bouton OK",
    image_reference: "screenshot_04.jpg",
  },
  {
    step_id: 5,
    category: "Mode Développeur",
    title: "Vérification de l'état",
    instruction:
      "Vérifiez que le toast 'Le mode développeur a été activé' s'affiche en bas de l'écran.",
    target_element: "Notification toast",
    image_reference: "screenshot_05.jpg",
  },
  {
    step_id: 6,
    category: "Mode Développeur",
    title: "Ouvrir les Options développeur",
    instruction:
      "Revenez au menu principal des Paramètres. Une nouvelle option 'Options pour les développeurs' est apparue en bas.",
    target_element: "Options pour les développeurs",
    image_reference: "screenshot_06.jpg",
  },
  {
    step_id: 7,
    category: "Prérequis Sécurité",
    title: "Accéder à la Sécurité",
    instruction:
      "Avant d'activer le débogage, allez dans 'Sécurité et confidentialité' pour modifier les restrictions de blocage.",
    target_element: "Sécurité et confidentialité",
    image_reference: "screenshot_07.jpg",
  },
  {
    step_id: 8,
    category: "Prérequis Sécurité",
    title: "Gérer le Bloqueur automatique",
    instruction:
      "Localisez l'option 'Bloqueur automatique' qui est activée par défaut.",
    target_element: "Bloqueur automatique",
    image_reference: "screenshot_08.jpg",
    skip_to: 11,
  },
  {
    step_id: 9,
    category: "Prérequis Sécurité",
    title: "Désactiver le blocage",
    instruction:
      "Appuyez sur 'Désactiver' dans la confirmation. Cette étape est indispensable pour autoriser l'installation via ADB.",
    target_element: "Bouton Désactiver",
    image_reference: "screenshot_09.jpg",
  },
  {
    step_id: 10,
    category: "Prérequis Sécurité",
    title: "Vérifier la désactivation",
    instruction:
      "Le commutateur du Bloqueur automatique doit maintenant être en position éteinte.",
    target_element: "Interrupteur gris",
    image_reference: "screenshot_10.jpg",
  },
  {
    step_id: 11,
    category: "Configuration ADB",
    title: "Autoriser le débogage USB",
    instruction:
      "Retournez dans les 'Options développeur', activez le 'Débogage USB' et validez la fenêtre d'avertissement en appuyant sur 'OK'.",
    target_element: "Bouton OK",
    image_reference: "screenshot_11.jpg",
  },
  {
    step_id: 12,
    category: "Configuration ADB",
    title: "Finaliser le paramétrage",
    instruction:
      "Assurez-vous que le 'Débogage USB' et le 'Débogage sans fil' sont tous deux activés.",
    target_element: "Débogage USB / Débogage sans fil",
    image_reference: "screenshot_12.jpg",
  },
];

export const adbAccessibilitySteps = [
  {
    step_id: 1,
    category: "Configuration de l'Accessibilité",
    title: "Ouvrir les paramètres d'accessibilité",
    instruction:
      "Dans le menu des Paramètres, recherchez et appuyez sur la section 'Accessibilité'.",
    target_element: "Accessibilité",
    image_reference: ".jpg",
  },
  {
    step_id: 2,
    category: "Configuration de l'Accessibilité",
    title: "Naviguer vers les applications installées",
    instruction:
      "Sélectionnez l'option 'Applications installées' pour accéder aux services tiers.",
    target_element: "Applications installées",
    image_reference: ".jpg",
  },
  {
    step_id: 3,
    category: "Configuration de l'Accessibilité",
    title: "Identifier l'application SAFE",
    instruction:
      "L'application est bien identifiée comme étant contrôlée par un paramètre restreint ,elle sera griser.",
    target_element: "SAFE",
    image_reference: "screenshot_3.jpg",
    skip_to: 8,
  },
  {
    step_id: 4,
    category: "Configuration de l'Accessibilité",
    title: "Consulter les détails de l'application",
    instruction:
      "Cliquer sur l'application pour Prendre connaissance du message d'alerte de sécurité expliquant les risques sur les données personnelles et fermer la fenêtre.",
    target_element: "SAFE",
    image_reference: "screenshot_4.jpg",
  },
  {
    step_id: 5,
    category: "Configuration de l'Accessibilité",
    title: "Rechercher l'application SAFE",
    instruction:
      "Rechercher l'application 'SAFE' dans la liste des applications installées et cliquer dessus.",
    target_element: "Application SAFE",
    image_reference: "screenshot_5.jpg",
  },
  {
    step_id: 6,
    category: "Configuration de l'Accessibilité",
    title: "Ouvrir les options de l'application",
    instruction:
      "Dans l'écran 'Infos sur l'appli', appuyer sur l'icône des trois points verticaux en haut à droite.",
    target_element: "Menu d'options (trois points)",
    image_reference: "screenshot_6.jpg",
  },
  {
    step_id: 7,
    category: "Configuration de l'Accessibilité",
    title: "Autoriser les paramètres restreints",
    instruction:
      "Sélectionner 'Autoriser les paramètres restreints' pour débloquer les autorisations spéciales de l'application.",
    target_element: "Option Autoriser les paramètres restreints",
    image_reference: "screenshot_7.jpg",
  },
  {
    step_id: 8,
    category: "Configuration de l'Accessibilité",
    title: "Sélectionner le service SAFE",
    instruction:
      "Localisez l'application 'SAFE' dans la liste. Elle doit être marquée comme 'Désactivé'.Elle ne sera pas/plus griser",
    target_element: "SAFE",
    image_reference: 8,
  },
  {
    step_id: 9,
    category: "Configuration de l'Accessibilité",
    title: "Activer le bouton de service",
    instruction:
      "Appuyez sur le commutateur 'Désactivé' pour initier l'activation du service.",
    target_element: "Commutateur Désactivé",
    image_reference: 9,
  },
  {
    step_id: 10,
    category: "Permissions Système",
    title: "Autoriser le contrôle total",
    instruction:
      "Une fenêtre de dialogue s'affiche. Lisez les permissions et appuyez sur 'Autoriser' pour confirmer.",
    target_element: "Bouton Autoriser",
    image_reference: 10,
  },
  {
    step_id: 11,
    category: "Configuration de l'Accessibilité",
    title: "Vérification de l'état",
    instruction:
      "Vérifiez que le service affiche désormais l'état 'Activé' en haut de l'écran.",
    target_element: "État Activé",
    image_reference: 11,
  },
  {
    step_id: 12,
    category: "Activation",
    title: "Validation USSD",
    instruction:
      "Ouvrez votre clavier numérique et composez le code *102# pour la suite du processus.",
    target_element: "*102#",
    image_reference: "screenshot_7.jpg",
  },
  {
    step_id: 13,
    category: "Compte SAFE",
    title: "Passer à la connexion",
    instruction:
      "Sur l'écran d'activation de licence, si vous avez déjà un compte, appuyez sur le lien 'J'ai déjà un compte'.Si vous n'avez pas de compte,renseignez le code de licence fourni et les autres informations",
    target_element: "J'ai déjà un compte",
    image_reference: "screenshot_8.jpg",
  },
  {
    step_id: 14,
    category: "Compte SAFE",
    title: "Saisie des identifiants",
    instruction:
      "Saisissez votre Pseudo et votre Code Pin (12 caractères requis).",
    target_element: "Formulaire de connexion",
    image_reference: "screenshot_9.jpg",
  },
  {
    step_id: 15,
    category: "Compte SAFE",
    title: "Valider la connexion",
    instruction: "Une fois les champs remplis, appuyez sur 'Accédez à SAFE'.",
    target_element: "Bouton Accédez à SAFE",
    image_reference: "screenshot_10.jpg",
  },
  {
    step_id: 16,
    category: "Privilèges Avancés",
    title: "Configuration Device Owner",
    instruction:
      "Si l'accès est restreint, copiez absolument la commande adb shell via l'icône de copie, vous en aurai besoin dans les étapes suivantes.",
    target_element: "Icône de copie de commande",
    image_reference: "screenshot_11.jpg",
  },
];

export const adbLadbSteps = [
  {
    step_id: 1,
    category: "Configuration LADB",
    title: "Recherche des paramètres",
    instruction:
      "Ouvrez les Paramètres de votre téléphone et appuyez sur l'icône de recherche en haut à droite.",
    target_element: "Icône Loupe",
    image_reference: "screenshot_01.jpg",
  },
  {
    step_id: 2,
    category: "Configuration LADB",
    title: "Rechercher le menu d'association",
    instruction:
      "Tapez le mot 'code' dans la barre de recherche pour filtrer les options de connectivité.",
    target_element: "Barre de recherche",
    image_reference: "screenshot_02.jpg",
  },
  {
    step_id: 3,
    category: "Configuration LADB",
    title: "Accéder à l'association sans fil",
    instruction:
      "Sélectionnez l'option 'Associer l'appareil avec un code d'association' sous le menu Débogage sans fil.",
    target_element: "Option d'association",
    image_reference: "screenshot_03.jpg",
  },
  {
    step_id: 4,
    category: "Configuration LADB",
    title: "Activer le Débogage sans fil",
    instruction:
      "Assurez-vous que l'interrupteur 'Débogage sans fil' est activé. Si ce n'est pas le cas, basculez-le.",
    target_element: "Commutateur Débogage sans fil",
    image_reference: "screenshot_04.jpg",
  },
  {
    step_id: 5,
    category: "Multitâche",
    title: "Préparer l'application LADB",
    instruction:
      "Localisez l'application LADB sur votre écran d'accueil et assurez-vous qu'elle est ouverte en arrière-plan.",
    target_element: "Icône LADB",
    image_reference: "screenshot_05.jpg",
  },
  {
    step_id: 6,
    category: "Multitâche",
    title: "Menu du mode fractionné",
    instruction:
      "Ouvrez le gestionnaire de tâches (applications récentes) et appuyez sur l'icône des Paramètres en haut de la fenêtre.",
    target_element: "Icône Paramètres (Multitâche)",
    image_reference: "screenshot_06.jpg",
  },
  {
    step_id: 7,
    category: "Multitâche",
    title: "Activer l'affichage fractionné",
    instruction:
      "Choisissez 'Ouvrir en affichage fractionné'. C'est une étape cruciale pour que le code d'association reste visible pendant la saisie.",
    target_element: "Ouvrir en affichage fractionné",
    image_reference: "screenshot_07.jpg",
  },
  {
    step_id: 8,
    category: "Multitâche",
    title: "Sélectionner LADB",
    instruction:
      "Dans la moitié inférieure de l'écran, sélectionnez l'application LADB pour l'ouvrir simultanément.",
    target_element: "Aperçu application LADB",
    image_reference: "screenshot_08.jpg",
  },
  {
    step_id: 9,
    category: "Appairage LADB",
    title: "Saisir les informations d'appairage",
    instruction:
      "Recopiez le 'Port' (les 5 derniers chiffres de l'adresse IP) et le 'Code d'association' affichés en haut dans les champs correspondants de LADB en bas.",
    target_element: "Champs Port et Pairing Code",
    image_reference: "screenshot_09.jpg",
  },
  {
    step_id: 10,
    category: "Appairage LADB",
    title: "Établissement de la connexion",
    instruction:
      "Attendez que LADB initialise le serveur ADB local. Le message 'Waiting for connection' devrait disparaître.",
    target_element: "Console LADB",
    image_reference: "screenshot_10.jpg",
  },
  {
    step_id: 11,
    category: "Exécution Shell",
    title: "Connexion Shell réussie",
    instruction:
      "Une fois connecté, la console affichera 'Entered adb shell Success!'. Vous pouvez maintenant entrer des commandes.",
    target_element: "Message de succès shell",
    image_reference: "screenshot_11.jpg",
  },
  {
    step_id: 12,
    category: "Exécution Shell",
    title: "Définition du Device Owner",
    instruction:
      "Saisissez la commande suivante : 'dpm set-device-owner com.detectedusb/.AdminReceiver' pour accorder les privilèges administrateur à l'application.",
    target_element: "Ligne de commande Shell",
    image_reference: "screenshot_12.jpg",
  },
  {
    step_id: 13,
    category: "Exécution Shell",
    title: "Confirmation de protection",
    instruction:
      "Le message de succès s'affiche et une notification confirme que la protection USB Guard est désormais activée.",
    target_element: "Toast de confirmation",
    image_reference: "screenshot_13.jpg",
  },
];
